export default "__VITE_ASSET__CboSYvMH__"